@if (ready) {
  <div class="row" style="height: 320px;">
    <div class="col-2 px-0 py-2" style="max-height: 320px;">
      <div class="custom-y-axis-labels">
        @for (data of series; track data) {
          <div class="label text-start" style="padding: 5px 0px;">
            <i class="ri-information-line" [ngbTooltip]="data.question"></i>
            {{ data.name }}
          </div>
        }
      </div>
    </div>
    <div class="col-10 p-0" style="max-height: 320px;">
      @if (ready) {
        <ngx-charts-heat-map class="dark" style="max-height: 320px;"
          [scheme]="colorScheme"
          [legend]="legend"
          [tooltipText]="tooltipText"
          [animations]="animations"
          [showXAxisLabel]="showXAxisLabel"
          [showYAxisLabel]="showYAxisLabel"
          [min]="min"
          [max]="max"
          [xAxis]="xAxis"
          [yAxis]="yAxis"
          [results]="chartData">
        </ngx-charts-heat-map>
      }
    </div>
  </div>
}
@if (!ready) {
  <div class="d-flex justify-content-center align-items-center" style="height: 320px;">
    <app-loading-spinner></app-loading-spinner>
  </div>
}